import { Component } from '@angular/core';

@Component({
  selector: 'app-input1',
  standalone: true,
  imports: [],
  templateUrl: './input1.component.html',
  styleUrl: './input1.component.scss'
})
export class Input1Component {

}
